import * as actionTypes from '../../actions/actionTypes';

const initialState = {
    loading: false,
    subscriptions: [],
    subscriptionDetails: {},
    monthlyUsages: {
        usages: [],
        hasNext: false,
        hasPrev: false,
    },
    weeklyUsages: {
        usages: [],
        hasNext: false,
        hasPrev: false,
    },
    activeSubscription: null,
    confirmText: null,
    paymentStatus: null,
    clientSubscriptionID: null,
    paymentLink: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_SUBSCRIPTIONS_LIST:
            return {
                ...state,
                loading: true,
            };
        case actionTypes.GET_SUBSCRIPTIONS_LIST_SUCCEEDED:
            return {
                ...state,
                subscriptions: action.payload,
                loading: false,
            };
        case actionTypes.GET_SUBSCRIPTION_DETAILS:
            return {
                ...state,
                loading: true,
            };
        case actionTypes.SET_SUBSCRIPTION_DETAILS:
            return {
                ...state,
                loading: false,
                subscriptionDetails: action.payload,
                monthlyUsages: action.monthlyUsages,
                weeklyUsages: action.weeklyUsages,
            };
        case actionTypes.SET_ACTIVE_SUBSCRIPTION:
            return {
                ...state,
                activeSubscription: action.payload,
            };
        case actionTypes.REMOVE_ACTIVE_SUBSCRIPTION:
            return {
                ...state,
                activeSubscription: null,
                paymentStatus: null,
                confirmText: null,
            };
        case actionTypes.SET_MONTHLY_USAGES:
            return {
                ...state,
                monthlyUsages: action.payload,
            };
        case actionTypes.SET_WEEKLY_USAGES:
            return {
                ...state,
                weeklyUsages: action.payload,
            }
        case actionTypes.SET_CONFIRM_TEXT:
            const { confirmText } = action.payload;
            return {
                ...state,
                confirmText,
                paymentLink: null,
            }
        case actionTypes.SET_PAYMENT_LINK: {
            const { paymentLink } = action.payload;
            return {
                ...state,
                paymentLink,
            }
        }
        case actionTypes.SUBSCRIPTIONS_SET_PAYMENT_STATUS: {
            const { status } = action.payload;
            return {
                ...state,
                paymentStatus: status,
            }
        }
        case actionTypes.SUBSCRIPTIONS_ITEM_BUY_SUCCEEDED: {
            const { id } = action.payload;
            return {
                ...state,
                clientSubscriptionID: id
            }
        }
        default:
            return state;
    }
}

export default reducer;
